import { render, staticRenderFns } from "./FiltriRiepilogoOre.vue?vue&type=template&id=52af5d8c&"
import script from "./FiltriRiepilogoOre.vue?vue&type=script&lang=js&"
export * from "./FiltriRiepilogoOre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports